import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { Metamodel } from 'app/model/base/model';
import { MicrosoftAccessTableDataset } from 'app/model/dataset/microsoft-access-table.dataset';
import { TabularCopySink } from './tabular.copysink';

@Metamodel.model({
    name: adfModelTypeMap.microsoftAccess.copySinkType,
    display: [],
    tags: {
        datasetModel: [
            Metamodel.modelFor(MicrosoftAccessTableDataset)
        ]
    }
})
export class MicrosoftAccessCopySink extends TabularCopySink {
}
